import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import img from "../../images/commentcamarche/Design sans titre (41) (1).png";
const Banner = () => {
  return (
    <>
      <div className="container px-4 mx-auto">
        <div className="grid items-center grid-cols-1 gap-8 md:grid-cols-2 mt-28">
          {/* Text Column */}
          <div className="text-left">
            <h1 className="text-3xl font-bold text-black dark:text-white md:text-5xl lg:text-[3.5rem]">
              Crééz, partagez, <br /> célébrez – nous <br /> trouvons le <br /> lieu
            </h1>

            <div className="mt-5 md:mt-10 lg:mt-8">
              <Link to="/location-evenement">
                <ButtonPrimary className="btn-text">En savoir plus</ButtonPrimary>
              </Link>
            </div>
          </div>

          <div>
            <img src={img} alt="Illustration" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
